<template>
  <Cart @submit="submit">
    <template #item="scope">
      <DuotoneBallItem :data="scope" />
    </template>
  </Cart>
</template>
<script setup>
import { api } from '@/plugins/axios.js'
import { useCartStore } from '@/stores/cart.js'
import Cart from './Cart.vue'
import DuotoneBallItem from './Items/DuotoneBallItem.vue'
import { useAuthStore } from '@/stores/auth'
import { useDialog } from '@/composables/useDialog'
import { useConfigStore } from '@/stores/config.js'
import { useQuasar } from 'quasar'

const cartStore = useCartStore()
const authStore = useAuthStore()
const configStore = useConfigStore()
const $q = useQuasar()
const { open } = useDialog()

async function submit () {
  if (cartStore.items.length !== 6){
    $q.notify({
      message: '6개의 숫자를 선택해주세요',
    })
    return false
  }

  open({ title: '배팅을 진행 하시겠습니까?' }).onOk(async () => {
    cartStore.submitting = true
    let balls = cartStore.items.filter((item, index) => index < 6).map(o => o.ball)
    await api.post('duotone-ball-bets', {
      duotone_ball_id: cartStore.items[0].duotoneBall.id,
      amount: cartStore.amount,
      balls,
    }).then(() => {
      cartStore.$reset()
    }).finally(() => {
      cartStore.submitting = false
    })
    await authStore.fetch()
    if ($q.screen.lt.md){
      configStore.rightDrawerOpen = false
    }
  })

}
</script>
